import { useContext } from "react";
import { AuditTrailContext } from "../contexts/AuditTrailContext";

export const useAuditTrail = () => useContext(AuditTrailContext);
